export default "__VITE_ASSET__3b2b52d5__"